import React, { useState, useEffect } from 'react';
import './CallLogs.css';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';

function CallLogs() {
    const [callLogData, setCallLogData] = useState([]);
    const [status, setStatus] = useState('PENDING');
    // const [isComplete, setIsComplete] = useState(false);
    // const [isIncomplete, setIsIncomplete] = useState(false);

    const { agentId } = useParams();

    const navigate = useNavigate();


    useEffect(() => {
        
        handleLogs(status);

    }, [agentId, status]);


    function handleLogs(status) {
      
        axios.get(`https://ad-prod.smytten.com/offline/misscalllog?agent_id=${agentId}&status=${status}`)
                .then((res) => {
                    console.log(res.data);
                    setCallLogData(res.data);
                    console.log(status,"status---new--")
                })
                .catch((error) => {
                    console.error(error);
                });
    }

    // console.log(callLogData, "details....");
    function handlePhoneDetails(id) {
        navigate(`/offline-frontend/leadlist/${agentId}/${id}`)
    }

    return (
        <div className='main-call-logs-container'>
            <h2 className='call-logs-text'>Call Logs</h2>
            <div className='all-logs-container'>
                <div className='total-logs-details-container'>
                    <div className='all-btns-logs'>
                        <Button variant="contained" className='logs-btn'>Total</Button>
                        <Button variant="contained" className='logs-btn' >Today</Button>
                    </div>
                    <div className='all-btns-logs-details'>
                        <p>{callLogData?.total_logs}</p>
                        <p>{callLogData?.today_logs}</p>

                    </div>
                </div>
                <div className='total-logs-container'>
                    <button
                    className= {`logs-btn ${status === 'CLOSED' ? 'grey-btn' : ''}`}
                        onClick={() => setStatus('CLOSED')}
                    >Completed</button>
                    <button 
                        className={`logs-btn ${status === 'PENDING' ? 'grey-btn' : ''}`}
                        onClick={() => setStatus('PENDING')}
                    >Incompleted</button>
                </div>

            </div>
            <div className='calls-logs-container'>

                {
                    callLogData?.call_logs?.map((call, index) => (
                        <div key={index} className='calls-logs-details'
                            onClick={() => handlePhoneDetails(call.id)}
                        >
                            <p className='call-phone-number'>
                                {call.caller_phone}
                            </p>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default CallLogs;